import { render } from "./ChangePwdForm.vue?vue&type=template&id=5d0771f6"
import script from "./ChangePwdForm.vue?vue&type=script&lang=js"
export * from "./ChangePwdForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__